import script from "./base-application-process-stages.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-application-process-stages.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__